module.exports = __webpack_public_path__ + "img/logo.b988c29e.png";